import { service } from '@ember/service';
import Component from '@glimmer/component';
import type StateService from 'garaje/services/state';
import { alias } from 'macro-decorators';

export default class extends Component {
  @service declare state: StateService;
  @alias('state.vrSubscription') vrSubscription!: StateService['vrSubscription'];
}
